<template>
	<div class="flower-spinner" v-if="loader">
		<div class="dots-container">
			<div class="bigger-dot">
				<div class="smaller-dot"></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			loader: false,
		}
	},
	mounted() {
		this.$store.subscribe((mutation, state) => {
			if (mutation.type === "setLoader") {
				this.loader = ["loader"]
			}
		})
		this.loader = this.$store.getters["loader"]
	},
}
</script>
<style scoped lang="scss">
$main-color: #09194f;
$sub-color: #00818a;
.flower-spinner,
.flower-spinner * {
	box-sizing: border-box;
}

.flower-spinner {
	height: 100vh;
	width: 100vw;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	background: rgba(255, 255, 255, 0.4);
	position: fixed;
	left: 0;
	top: 0;
	z-index: 999;
}

.flower-spinner .dots-container {
	height: calc(70px / 7);
	width: calc(70px / 7);
}

.flower-spinner .smaller-dot {
	background: $sub-color;
	height: 100%;
	width: 100%;
	border-radius: 50%;
	animation: flower-spinner-smaller-dot-animation 2.5s 0s infinite both;
}

.flower-spinner .bigger-dot {
	background: $sub-color;
	height: 100%;
	width: 100%;
	padding: 10%;
	border-radius: 50%;
	animation: flower-spinner-bigger-dot-animation 2.5s 0s infinite both;
}

@keyframes flower-spinner-bigger-dot-animation {
	0%,
	100% {
		box-shadow: $main-color 0px 0px 0px, $main-color 0px 0px 0px, $main-color 0px 0px 0px,
			$main-color 0px 0px 0px, $main-color 0px 0px 0px, $main-color 0px 0px 0px,
			$main-color 0px 0px 0px, $main-color 0px 0px 0px;
	}

	50% {
		transform: rotate(180deg);
	}

	25%,
	75% {
		box-shadow: $main-color 26px 0px 0px, $main-color -26px 0px 0px, $main-color 0px 26px 0px,
			$main-color 0px -26px 0px, $main-color 19px -19px 0px, $main-color 19px 19px 0px,
			$main-color -19px -19px 0px, $main-color -19px 19px 0px;
	}

	100% {
		transform: rotate(360deg);
		box-shadow: $main-color 0px 0px 0px, $main-color 0px 0px 0px, $main-color 0px 0px 0px,
			$main-color 0px 0px 0px, $main-color 0px 0px 0px, $main-color 0px 0px 0px,
			$main-color 0px 0px 0px, $main-color 0px 0px 0px;
	}
}

@keyframes flower-spinner-smaller-dot-animation {
	0%,
	100% {
		box-shadow: $main-color 0px 0px 0px, $main-color 0px 0px 0px, $main-color 0px 0px 0px,
			$main-color 0px 0px 0px, $main-color 0px 0px 0px, $main-color 0px 0px 0px,
			$main-color 0px 0px 0px, $main-color 0px 0px 0px;
	}

	25%,
	75% {
		box-shadow: $main-color 14px 0px 0px, $main-color -14px 0px 0px, $main-color 0px 14px 0px,
			$main-color 0px -14px 0px, $main-color 10px -10px 0px, $main-color 10px 10px 0px,
			$main-color -10px -10px 0px, $main-color -10px 10px 0px;
	}

	100% {
		box-shadow: $main-color 0px 0px 0px, $main-color 0px 0px 0px, $main-color 0px 0px 0px,
			$main-color 0px 0px 0px, $main-color 0px 0px 0px, $main-color 0px 0px 0px,
			$main-color 0px 0px 0px, $main-color 0px 0px 0px;
	}
}
</style>